import { getValueConfigCat } from '@grupoboticario/barril-del-chavo'
import { getConfig, User } from 'src/helpers'

export const useCatalogVariation = () => {
  const localFlag = localStorage.getItem('catalogVariant')
  const { isEuAmoMake } = getConfig()

  const getCatalogVariant = async () => {
    if (!isEuAmoMake) {
      return null
    }

    if (localFlag) {
      return localFlag
    }

    const featureFlag = await getValueConfigCat({
      key: 'catalogVariation',
      default: false,
      userIdentifier: User.getInstance().getUserId(),
    })
    const catalogVariant = featureFlag ? 'b' : 'a'
    localStorage.setItem('catalogVariant', catalogVariant)

    return catalogVariant
  }

  return { getCatalogVariant }
}
